import { Component, HostBinding, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-alert-banner',
    templateUrl: './alert-banner.component.html',
    styleUrls: ['./alert-banner.component.scss'],
    standalone: false
})
export class AlertBannerComponent {
  @Input() type: string;
  @Input() message: string;
  @Input() header?: string; // Optional header
  @Input() buttonName?: string; // Optional button text
  @Output() buttonAction = new EventEmitter<void>(); // Optional button action

  getBannerClass(): string {
    return {
      'information': 'info_banner',
      'success': 'success_banner',
      'error': 'error_banner'
    }[this.type] || '';
  }

  handleButtonClick() {
    if (this.buttonAction) {
      this.buttonAction.emit();
    }
  }
}
